import React, { useEffect, useState } from "react";
import LogoSlider from "./logo_slider";
import SocialIcons from "./social_icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as ctf from 'contentful';
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import parse from 'html-react-parser';
import Slider from "react-slick";
import Marquee from "react-fast-marquee";

const About = () => {
  const [about, setAbout] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [award, setAward] = useState([]);
  console.log("Testimonial", award)
  const client = ctf.createClient({
    space: 'fdtw7gymput4',
    accessToken: '-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E'
  });

  useEffect(() => {

    fetchDataProject();
    fetchDataTestimonial();
    fetchDataAward();

  }, []);

  const fetchDataProject = async () => {
    try {
      const resp = await client.getEntries({ content_type: 'aboutPage' });
      setAbout(resp.items);
    } catch (error) {
      console.log(error);
    }

  }
  const fetchDataTestimonial = async () => {
    try {
      const resp = await client.getEntries({ content_type: 'testimonial' });
      setTestimonial(resp.items);
    } catch (error) {
      console.log(error);
    }

  }
  const fetchDataAward = async () => {
    try {
      const resp = await client.getEntries({ content_type: 'awards' });
      setAward(resp.items);
    } catch (error) {
      console.log(error);
    }

  }
  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };


  return (
    <div>
      <div className="about-info">
        <div>
          <h1 className="text-black contact_heading py-3" style={{ fontSize: '90px', marginTop: '60px' }} >About Us</h1>
        </div>
        <div>
          <h3 className="color-yellow">LITTLEBIG</h3>
        </div>
        <div className="about-short-info">
          {about[0]?.fields?.aboutText && (
            parse(documentToHtmlString(about[0]?.fields?.aboutText))
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-7 col-md-7 col-12 logos_animations mobile_margin_top ">
          <div className="about-info">
            <h3 className="text-black mb-4 mt-0 text-bold">Awards</h3>
            <div className="row">
              {award && award[0]?.fields?.awardLogo?.map((item) => {
                return (
                  <div style={{ margin: '0px 0.8rem' }}>
                    <img src={`https:${item?.fields?.file?.url}`} width="100%" alt="" />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-5 col-md-5 col-12 mobile_margin_top logos_animations">
          <Slider {...settings}>
            {testimonial && testimonial[0]?.fields?.testimonialFields.map((item) => {
              return (
                <div className="px-2">
                  <div className="co-founder">

                  </div>
                  <div className="co-founder-info mt-5">
                    <p>
                      {item?.fields?.description}
                    </p>
                    <p>
                      <em>
                        {item?.fields?.testimonialName}
                        <span> {item?.fields?.designation}</span>
                      </em>
                    </p>
                  </div>
                </div>
              )
            })}

          </Slider>
        </div>
      </div>
      <div className="logos_animations">
        <LogoSlider />
      </div>

      <SocialIcons />
    </div>
  );
};

export default About;
